import Column from '@components/column'
import Row from '@components/row'
import Button from '@components/button'
import Image from '@components/image'
import Typography from '@components/typography'
import Fields from '@components/fields'
import { Formik, Form } from 'formik'
import { Fragment, useEffect, useState } from 'react'
import { styleInputWrapper } from './style'
import { useSelector } from 'react-redux'
import { Category } from '@apis'
import Svg from '@components/svg'
import Modal from '@components/modal'
import ChooseCategories from '@commons/popups/categories'
import { DepartmentSchema } from '@validations'
import { useLocation, useNavigate } from 'react-router-dom'
const DepartmentForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const { data: departments } = useSelector((state: any) => state.departments)
  const [visible, setVisible] = useState<boolean>(false)
  const [chooseVisible, setChooseVisible] = useState<boolean>(false)
  const [initialValues, setInitialValues] = useState<any>({
    name: '',
    image: '',
    parentId: '',
    symptoms: [],
  })

  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values: any, { resetForm }) => {
    const payload: any = {
      type: 'Specialization',
      name: values?.name,
      infos: {
        parentId: values?.parentId,
      },
    }

    payload.infos = {
      ...payload.infos,
      image: !!values?.image?.base64
        ? {
            base64: values?.image?.base64,
            extension: values?.image?.extension,
          }
        : values?.image,
    }

    if (!!values?.symptoms?.length) {
      payload.symptoms = values?.symptoms?.map((item: any) => item?.id)
    }
    setLoading(true)
    if (!!state?.id) {
      await Category.update({
        data: payload,
        id: state?.id,
        state: 'specializations',
      })
        .then(() => {
          navigate('/admin/category-management?tab=department')
        })
        .catch(() => {})
    } else {
      await Category.create({
        data: payload,
        state: 'specializations',
      })
        .then(() => {
          resetForm()
        })
        .catch(() => {})
    }
    setLoading(false)
  }
  const departmentSubmitHandler = async (values) => {
    const payload = {
      name: values?.name,
      type: 'Department',
    }
    setLoading(loading)
    await Category.create({
      data: payload,
      state: 'departments',
    })
      .then((resp) => {
        setVisible(false)
        setInitialValues({
          ...initialValues,
          parentId: resp?.id,
        })
      })
      .catch(() => {})

    setLoading(false)
  }
  const fetchDepartments = async () => {
    await Category.list({
      state: 'departments',
      params: {
        type: 'Department',
      },
    }).catch(() => {})
  }

  useEffect(() => {
    if (!departments?.length) {
      fetchDepartments()
    }
  }, [])

  useEffect(() => {
    if (!!state?.id) {
      setInitialValues({
        name: state?.name,
        image: state?.infos?.image,
        parentId: state?.infos?.parentId,
        symptoms: state?.symptoms,
      })
    } else {
      setInitialValues({
        name: '',
        image: '',
      })
    }
  }, [state?.id])

  return (
    <>
      <Column bg="white" styleColumn="padding:30px;border-radius:8px;">
        <Formik
          initialValues={initialValues}
          onSubmit={submitHandler}
          enableReinitialize
          validationSchema={DepartmentSchema.validationSchema}
        >
          {({ handleSubmit, setFieldValue, values }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Column rowGap={20}>
                  <Row justifyContent="space-between">
                    <Fields.DropDown
                      label="Department Category"
                      name="parentId"
                      options={departments}
                      titleAsKey="name"
                      valueAsKey="id"
                      placeholder="Enter Department Name"
                      styleWrapper={styleInputWrapper}
                      hasSearch
                      rightComponent={
                        <div
                          onClick={(event) => {
                            event.stopPropagation()
                            setVisible(true)
                          }}
                        >
                          <Svg svg="circlePlus" />
                        </div>
                      }
                    />
                    <Fields.Input
                      label="Add Specialization"
                      name="name"
                      placeholder="Enter Specialization"
                      styleWrapper={styleInputWrapper}
                    />
                    <Fields.Upload
                      size={100}
                      varient="drag"
                      label="Symptoms & Problem Icon"
                      name="image"
                      placeholder="Upload file or image"
                      styleWrapper={styleInputWrapper}
                    />
                  </Row>
                  <Button
                    outline
                    title="Add Symptoms & Problems"
                    onClick={() => {
                      setChooseVisible(true)
                    }}
                  />
                  {!!values?.symptoms?.length && (
                    <Row colGap={20}>
                      {values?.symptoms?.map((symptom: any) => {
                        return (
                          <Fragment key={symptom?.id}>
                            <Column rowGap={5}>
                              <Image
                                width={50}
                                height={50}
                                styleImage={`border-radius:50%;`}
                                src={`${process.env.BUCKET_URL}/${symptom?.infos?.image}`}
                              />
                              <Typography
                                content={symptom?.name}
                                size={12}
                                styleText="text-align:center"
                              />
                            </Column>
                          </Fragment>
                        )
                      })}
                    </Row>
                  )}

                  <ChooseCategories
                    visible={chooseVisible}
                    selectedItems={values?.symptoms}
                    setVisible={setChooseVisible}
                    onClick={(item: any) => {
                      const findIndex = values?.symptoms?.findIndex(
                        (selected: any) => selected?.id == item.id,
                      )
                      if (findIndex >= 0) {
                        setFieldValue(
                          'symptoms',
                          values?.symptoms?.filter(
                            (symptom) => symptom?.id != item?.id,
                          ),
                        )
                      } else {
                        setFieldValue('symptoms', [
                          ...(values?.symptoms || []),
                          item,
                        ])
                      }
                    }}
                    title="Symptoms & Problems"
                    selector="symptoms"
                    type="Symptom"
                  />
                  <Column alignItems="flex-end">
                    <Button
                      type="submit"
                      title="Save"
                      styleButton="width:150px;"
                      height={45}
                      loading={loading}
                    />
                  </Column>
                </Column>
              </Form>
            )
          }}
        </Formik>
      </Column>
      <Modal
        visible={visible}
        onClose={() => {
          setVisible(false)
        }}
      >
        <Formik
          initialValues={{
            name: '',
          }}
          onSubmit={departmentSubmitHandler}
        >
          {({ handleSubmit }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Column rowGap={15}>
                  <Fields.Input
                    name="name"
                    placeholder="Enter Department Name"
                    label="Department Name"
                  />
                  <Column alignItems="flex-end">
                    <Button
                      type="submit"
                      title="Save"
                      height={40}
                      loading={loading}
                    />
                  </Column>
                </Column>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}
export default DepartmentForm
